import i18n from '@/main';

export default {
    getMessage(code) {
        return i18n.t(code);
    }
};
